<template>
  <div class="card-data">
    <div class="preview" v-if="loader">
      <div class="preview-img-data">
        <transition name="fadeImg" mode="out-in"> 
          <div :key="key" class="offer" :style="{'background-image': 'url(' + imageHost +')'}" alt="image"></div>
        </transition>
          <div class="preview-data" >
            <transition name="fade" mode="out-in"> 
              <div class="title-subtitle" :key="key">
                <p class="title"  >{{offers.name}}</p>
                <p class="subtitle">{{offers.description}}</p>
                <div class="button sm secondary">
                    <p>{{offers.button_text}}</p>
                </div>
              </div>
            </transition>
          </div>  
      </div>
      <div class="categories">
        <ul>
          <li class="category" :class="offers.category[0].id==1 ? 'active' : ''">
            <span class="img-cat category-1" :class="offers.category[0].id==1? 'active-cat-1' : ''"></span>
            <p class="category-name">{{firstCategory}}</p>
          </li>
          <span class="divider"></span>
          <li class="category" :class="offers.category[0].id==2 ? 'active' : ''">
            <span class="img-cat category-2" :class="offers.category[0].id==2 ? 'active-cat-2' : ''"></span>
            <p class="category-name">{{secondCategory}}</p>
          </li>
          <span class="divider" v-if="thirdCategory"></span>
          <li class="category" :class="offers.category[0].id==3 ? 'active' : ''" v-if="thirdCategory">
            <span class="img-cat category-3" :class="offers.category[0].id==3 ? 'active-cat-3' : ''"></span>
            <p class="category-name">{{thirdCategory}}</p>
          </li>
          <span class="divider" v-if="fourCategory"></span>
          <li class="category" :class="offers.category[0].id==4 ? 'active' : ''" v-if="fourCategory">
            <span class="img-cat category-4" :class="offers.category[0].id==4 ? 'active-cat-4' : ''"></span>
            <p class="category-name">{{fourCategory}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div v-else-if="!nodata">
      <EmptyStateChart
      :title="titleEmpty"
      :caption="captionEmpty"
      />
    </div> -->
    <div v-else>
      <Loader/>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader'
// import EmptyStateChart from '@/components/EmptyStateChart'
export default {
  name: "PreviewCard",
  components: {
    Loader,
    // EmptyStateChart
  },
  props: {
    offers :{
      type: Object,
      required: true
    },
    firstCategory: {
      type: String
    },
    secondCategory: {
      type: String
    },
    thirdCategory: {
      type: String
    },
    fourCategory: {
      type: String
    },
    captionEmpty:{
        type: String,
        default: "Puedes consultar la vista de los últimos 7 o 30 días.",
    },
    titleEmpty: {
        type: String,
        default: "Este gráfico no esta disponible para esta vista"
    },
    loader: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      key: 0,
      imageUrl: this.offers.images
    }
  },
  watch: {
      offers:{
        handler(){
          this.key++
        },
        deep: true
      }
  },
  computed: {
        imageHost: function() {
            return process.env.VUE_APP_CORE_HOST + this.offers.images
        },
        nodata: function(){
          return this.offers ? true : false
        }
  }
}
</script>
<style lang="sass">
.preview
  display: flex
  flex-direction: column
  width: 265px
  position: relative
  min-height: 540px
  justify-content: space-between
  @include mobile
    display: none
  @include tablet-portrait
    min-height: 430px
  .preview-img-data
    margin-top: $xs
    display: flex
    background-color: $lighter-grey
    border-radius: 4px
    height: 420px
    @include tablet-portrait
      height: 350px
  .offer
    position: relative
    margin: 0px
    z-index: 1
    width: 265px
    height: 420px
    background-size: cover
    background-position: center center
    border-radius: 4px
    @include tablet-portrait
      height: 350px
   
  .preview-data
    font-family: $body-font
    display: flex
    flex-direction: column-reverse
    align-items: flex-end
    box-sizing: border-box
    position: absolute
    width: 265px
    height: 420px
    background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.75) 72%)
    z-index: 2
    border-radius: 4px
    overflow: hidden
    @include tablet-portrait
      height: 350px
    .title-subtitle
      margin-bottom: $sm
      width: 100%
    .title
      font-weight: bold
      font-size: 16px
      text-align: right
      width: 100%
      color: $white
      order: 2
      padding: 0px 8px
      box-sizing: border-box
    .subtitle
      text-align: right
      width: 100%
      font-weight: 200
      color: $white
      order: 1
      font-size: 12px
      padding: 0px 8px
      margin-top: $xs
      box-sizing: border-box
      margin-bottom: $md
    .button
      order: 3
      margin-bottom: $sm
      width: 60%
      margin: auto
  .categories
    display: flex
    flex-direction: row
    align-items: center
    width: 100%
    background: $white
    margin-top: $sm
    ul
      display: flex
      justify-content: space-evenly
      width: 100%
      align-items: flex-start
      list-style-type: none
      align-self: center
      background-color: $white
      padding: 4px
      li
        align-items: center
        .img-cat
          width: 32px
          height: 32px
          display: block
          background-position: 0% 0% 
          margin-bottom: $xs
        .category-1
          background: url(../../assets/icons/categories/cat-01-in.svg) no-repeat center
        .category-2
          background: url(../../assets/icons/categories/cat-02-in.svg) no-repeat center
        .category-3
          background: url(../../assets/icons/categories/cat-03-in.svg) no-repeat center
        .category-4
          background: url(../../assets/icons/categories/cat-04-in.svg) no-repeat center
        .active-cat-1
          background: url(../../assets/icons/categories/cat-01-ac.svg) no-repeat center
        .active-cat-2
          background: url(../../assets/icons/categories/cat-02-ac.svg) no-repeat center
        .active-cat-3
          background: url(../../assets/icons/categories/cat-03-ac.svg) no-repeat center
        .active-cat-4
          background: url(../../assets/icons/categories/cat-04-ac.svg) no-repeat center
    .divider
      width: 1px
      height: 24px
      border: none
      display: flex
      background: $secondary
      border-radius: 8px
    .category
      flex-grow: 1
      display: flex
      flex-direction: column
      opacity: 0.6
      width: 30%
      .category-name
        font-family: $title-font
        font-size: 10px
        text-align: center
        font-weight: bold
      &.active
        color: $secondary
        opacity: 0.6

.fade-enter-active, .fade-leave-active 
  transition: all .3s

.fade-enter, .fade-leave-to  
  opacity: 0
  margin-right: -10px

.fadeImg-enter-active, .fadeImg-leave-active 
  transition: all .2s

.fadeImg-enter, .fadeImg-leave-to 
  opacity: 0
  

</style>